import "react/jsx-runtime";
import { useContext, createContext } from "react";
createContext(void 0);
const r = createContext(null);
function m(t) {
  const n = useContext(r);
  if (n) return n.signals.get(t);
}
export {
  m as useBlockSignal
};
